export const SELECT_DASHBOARD_FILTER_TAB = 'SELECT_DASHBOARD_FILTER_TAB'

export const ADD_DIALOGS = 'ADD_DIALOGS'

export const RENAME_DIALOG = 'RENAME_DIALOG'

export const SAVE_BOT = 'SAVE_BOT'
export const SAVE_BOT_SUCCESS = 'SAVE_BOT_SUCCESS'
export const SAVE_BOT_FAILURE = 'SAVE_BOT_FAILURE'

export const MOVE_STEP = 'MOVE_STEP'

export const MOVE_ANSWER = 'MOVE_ANSWER'

export const UPDATE_STEP_PROPERTIES = 'UPDATE_STEP_PROPERTIES'
export const REPLACE_STEP = 'UPDATE_STEP'

export const UPDATE_BOT_PROPERTIES = 'UPDATE_BOT_PROPERTIES'

export const DELETE_DIALOG_OCCURENCES = 'DELETE_DIALOG_OCCURENCES'

export const DELETE_STEP = 'DELETE_STEP'

export const ADD_STEP = 'ADD_STEP'

export const STEP_ACTION = 'STEP_ACTION'

export const DELETE_DIALOGS = 'DELETE_DIALOGS'

export const GET_USERS = 'GET_USERS'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'

export const ADD_USER_PLACEHOLDER = 'ADD_USER_PLACEHOLDER'
export const RESET_USER_PLACEHOLDER = 'RESET_USER_PLACEHOLDER'

export const ADD_USER = 'ADD_USER'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE'

export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'

export const GET_DOMAINS = 'GET_DOMAINS'
export const GET_DOMAINS_SUCCESS = 'GET_DOMAINS_SUCCESS'
export const GET_DOMAINS_FAILURE = 'GET_DOMAINS_FAILURE'

export const ADD_DOMAIN_PLACEHOLDER = 'ADD_DOMAIN_PLACEHOLDER'

export const ADD_DOMAIN = 'ADD_DOMAIN'
export const ADD_DOMAIN_SUCCESS = 'ADD_DOMAIN_SUCCESS'
export const ADD_DOMAIN_FAILURE = 'ADD_DOMAIN_FAILURE'

export const UPDATE_DOMAIN = 'UPDATE_DOMAIN'
export const UPDATE_DOMAIN_SUCCESS = 'UPDATE_DOMAIN_SUCCESS'
export const UPDATE_DOMAIN_FAILURE = 'UPDATE_DOMAIN_FAILURE'

export const DELETE_DOMAIN = 'DELETE_DOMAIN'
export const DELETE_DOMAIN_SUCCESS = 'DELETE_DOMAIN_SUCCESS'
export const DELETE_DOMAIN_FAILURE = 'DELETE_DOMAIN_FAILURE'

export const APPLY_DIFF = 'APPLY_DIFF'

export const DISCARD_CHANGES = 'DISCARD_CHANGES'

export const STRIP_API_KEY_FROM_API_URL = 'STRIP_API_KEY_FROM_URL'
export const STRIP_SDK_VERSION_FROM_BOT = 'STRIP_SDK_VERSION_FROM_BOT'

export const DISABLE_STEP_NLP_IN_STEP_TYPE_DEFAULTS = 'DISABLE_STEP_NLP_IN_STEP_TYPE_DEFAULTS'
